import React, { useCallback } from 'react';
import YesNoDialog from 'components/common/dialog/YesNoDialog';
import confirmDialogVar from './variables';
import { useReactiveVar } from '@apollo/client';

const GlobalConfirmDialog = () => {
  const data = useReactiveVar(confirmDialogVar);

  const close = useCallback(() => confirmDialogVar({ ...data, open: false }), [data]);

  const confirm = useCallback(() => {
    data.callback();
    close();
  }, [data, close]);

  return <YesNoDialog title={data.options.title} content={data.options.content} open={data.open} onClose={close} onConfirm={confirm} />;
};

export default GlobalConfirmDialog;
